import {
  BrandConfig,
  BrandFeaturesConfig,
  defaultBrandConfig,
  defaultBrandFeaturesConfig,
  defaultCurrency,
  defaultEnvConfig,
  defaultLocale,
  EnvConfig,
} from 'src/configurations'
import { ExtendCurrency, ExtendLocales } from 'src/enums'
import {
  RemoteConfigModel,
  RemoteConfigResponse,
} from 'src/models/remoteConfig.models'
import ConfigReducer, {
  Actions as ConfigActions,
  ConfigState,
  initialState as initialConfigState,
} from 'src/redux/reducers/data/config.reducer'
import FeatureFlaggerReducer, {
  Actions as FeatureFlaggerActions,
} from 'src/redux/reducers/data/featureFlagger.reducer'
import RemoteConfigReducer, {
  Actions as RemoteConfigActions,
} from 'src/redux/reducers/data/remoteConfig.reducer'

export interface SessionState {
  brandConfig: BrandConfig
  brandFeaturesConfig: BrandFeaturesConfig
  envConfig: EnvConfig
  defaultLocale: ExtendLocales
  defaultCurrency: ExtendCurrency
  remoteConfig: RemoteConfigModel
  featureFlagger: Partial<RemoteConfigResponse>
  config: ConfigState
}

export const initialState: SessionState = {
  brandConfig: defaultBrandConfig,
  brandFeaturesConfig: defaultBrandFeaturesConfig,
  envConfig: defaultEnvConfig,
  defaultCurrency: defaultCurrency,
  defaultLocale: defaultLocale,
  remoteConfig: RemoteConfigModel.defaultConfig(),
  featureFlagger: {},
  config: initialConfigState,
}
export type Actions =
  | ConfigActions
  | RemoteConfigActions
  | FeatureFlaggerActions

const SessionReducer = (
  state: SessionState = initialState,
  action: Actions,
): SessionState => {
  return {
    ...state,
    remoteConfig: RemoteConfigReducer(
      state.remoteConfig,
      action as RemoteConfigActions,
    ),
    config: ConfigReducer(state.config, action as ConfigActions),
    featureFlagger: FeatureFlaggerReducer(
      state.featureFlagger,
      action as FeatureFlaggerActions,
    ),
  }
}

export default SessionReducer
